export enum BalanceType {
  GIFT_CARD = "GIFT_CARD",
  HOUSE_ACCOUNT = "HOUSE_ACCOUNT",
  ORDER_CLEARING = "ORDER_CLEARING",
}
